import React from 'react';
import { Routes as RouterRoutes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import ErrorBoundary from './components/ErrorBoundary';
import ProtectedRoute from './components/ProtectedRoute';
// Pages
import NotFound from './pages/NotFound';
import Login from './pages/login';
import Register from './pages/register';
import PasswordReset from './pages/password-reset';
import EventDiscovery from './pages/event-discovery';
import EventDetails from './pages/event-details';
import EventCreation from './pages/event-creation';
import UserProfile from './pages/user-profile';
import MessagingCenter from './pages/messaging-center';
import SpotGuide from './pages/spot-guide';
import SpotDetails from './pages/spot-details';
import UserMarketplace from './pages/user-marketplace';
import MarketplaceDetails from './pages/marketplace-details';
import OfficialStore from './pages/official-store';
import AdminDashboard from './pages/admin-dashboard';
import OnboardingFlow from './pages/onboarding-flow';
import MyTickets from './pages/my-tickets';
import OrganizerCheckInInterface from './pages/organizer-check-in-interface';
import CancellationRequestManagement from './pages/cancellation-request-management';
import SupportTicketDashboard from './pages/support-ticket-dashboard';
import SupportTicketSystemUserInterface from './pages/support-ticket-system-user-interface';
import TicketCreationManagement from './pages/ticket-creation-management';
import AgentWorkspace from "./pages/agent-workspace";
import CheckoutPage from './pages/checkout/CheckoutPage';
import PaymentSuccess from './pages/checkout/PaymentSuccess';
import PaymentFailed from './pages/checkout/PaymentFailed';
import ShoppingCartManagement from './pages/shopping-cart-management';
import AdvancedCheckoutSystem from './pages/advanced-checkout-system';
import OrderConfirmation from './pages/order-confirmation';
import OrderHistory from './pages/order-history';
import LandingPage from './pages/landing-page';
import MyFavorites from './pages/my-favorites';
import AdminRideManagement from './pages/admin-ride-management';
import PublicProfile from './pages/public-profile-view';
import Community from './pages/community';
import BlogListing from './pages/blog-listing';
import BlogPostEditor from './pages/blog-post-editor';
import BlogDetail from './pages/blog-detail';
import BlogManagementDashboard from './pages/blog-management-dashboard/index';
import SupportTicketSystemAdminPanel from './pages/support-ticket-system-admin-panel';
import OrderTrackingDashboard from './pages/order-tracking-dashboard';
import ShippingManagementCenter from './pages/shipping-management-center';
import DeliveryConfirmationSystem from './pages/delivery-confirmation-system';
import StoreAdminManagementCenter from './pages/store-admin-management-center';
import RegistrationSuccess from './pages/registration-success';
import CheckoutSuccess from './pages/checkout-success';
import IletisimPage from './pages/iletisim';
import HakkimizdaPage from './pages/hakkimizda';
import { MesafeliSatisSozlesmesi, IptalIadeKosullari, TeslimatPolitikasi, KvkkGizlilikPolitikasi } from './pages/legal';
import InvoiceAuditDashboard from './pages/invoice-audit-dashboard';
import EventInvoiceComplianceDashboard from './pages/event-invoice-compliance';
import MasterInvoiceCenter from './pages/master-invoice-center';
import PaymentGateway from './pages/payment-gateway';
function Routes() {
  return (
    <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Public Routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/registration-success" element={<RegistrationSuccess />} />
        <Route path="/password-reset" element={<PasswordReset />} />
        <Route path="/password-reset/update" element={<PasswordReset />} />
        <Route path="/" element={<LandingPage />} />
        <Route path="/payment-gateway" element={<PaymentGateway />} />
        <Route path="/checkout-success" element={<CheckoutSuccess />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/payment-failed" element={<PaymentFailed />} />
        <Route path="/event-discovery" element={<EventDiscovery />} />
        <Route path="/event-details/:id" element={<EventDetails />} />
        <Route path="/event-creation" element={<EventCreation />} />
        <Route path="/spot-guide" element={<SpotGuide />} />
        <Route path="/spot-details/:id" element={<SpotDetails />} />
        <Route path="/user-marketplace" element={<UserMarketplace />} />
        <Route path="/official-store" element={<OfficialStore />} />
        <Route path="/onboarding-flow" element={<OnboardingFlow />} />
        <Route path="/organizer-check-in-interface/:eventId" element={<OrganizerCheckInInterface />} />
        <Route path="/support-ticket-dashboard" element={<SupportTicketDashboard />} />
        <Route path="/support-ticket-system-user-interface" element={<SupportTicketSystemUserInterface />} />
        <Route path="/support-ticket-system-admin-panel" element={<SupportTicketSystemAdminPanel />} />
        <Route path="/ticket-creation-management" element={<TicketCreationManagement />} />
        <Route path="/agent-workspace" element={<AgentWorkspace />} />
        <Route path="/order-confirmation/:orderId" element={<OrderConfirmation />} />
        <Route path="/blog-listing" element={<BlogListing />} />
        <Route path="/blog/:slug" element={<BlogDetail />} />
        <Route path="/iletisim" element={<IletisimPage />} />
        <Route path="/hakkimizda" element={<HakkimizdaPage />} />
        <Route path="/mesafeli-satis-sozlesmesi" element={<MesafeliSatisSozlesmesi />} />
        <Route path="/iptal-iade-kosullari" element={<IptalIadeKosullari />} />
        <Route path="/teslimat-politikasi" element={<TeslimatPolitikasi />} />
        <Route path="/kvkk-gizlilik-politikasi" element={<KvkkGizlilikPolitikasi />} />
        {/* Protected User Routes */}
        <Route path="/user-profile" element={<ProtectedRoute><UserProfile /></ProtectedRoute>} />
        <Route path="/profile/:userId" element={<ProtectedRoute><PublicProfile /></ProtectedRoute>} />
        <Route path="/my-tickets" element={<ProtectedRoute><MyTickets /></ProtectedRoute>} />
        <Route path="/my-favorites" element={<ProtectedRoute><MyFavorites /></ProtectedRoute>} />
        <Route path="/messaging-center" element={<ProtectedRoute><MessagingCenter /></ProtectedRoute>} />
        <Route path="/marketplace/:id" element={<ProtectedRoute><MarketplaceDetails /></ProtectedRoute>} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/shopping-cart-management" element={<ShoppingCartManagement />} />
        <Route path="/advanced-checkout-system" element={<ProtectedRoute><AdvancedCheckoutSystem /></ProtectedRoute>} />
        <Route path="/order-history" element={<ProtectedRoute><OrderHistory /></ProtectedRoute>} />
        <Route path="/order-tracking-dashboard" element={<ProtectedRoute><OrderTrackingDashboard /></ProtectedRoute>} />
        <Route path="/delivery-confirmation-system" element={<ProtectedRoute><DeliveryConfirmationSystem /></ProtectedRoute>} />
        {/* Protected Admin Routes */}
        <Route path="/admin-dashboard" element={<ProtectedRoute requireAdmin={true}><AdminDashboard /></ProtectedRoute>} />
        <Route path="/admin/community" element={<ProtectedRoute requireAdmin={true}><Community onUserClick={() => {}} /></ProtectedRoute>} />
        <Route path="/cancellation-request-management" element={<ProtectedRoute requireAdmin={true}><CancellationRequestManagement /></ProtectedRoute>} />
        <Route path="/admin-ride-management" element={<ProtectedRoute requireAdmin={true}><AdminRideManagement /></ProtectedRoute>} />
        <Route path="/blog-management-dashboard" element={<ProtectedRoute requireAdmin={true}><BlogManagementDashboard /></ProtectedRoute>} />
        <Route path="/blog-post-editor" element={<ProtectedRoute requireAdmin={true}><BlogPostEditor /></ProtectedRoute>} />
        <Route path="/shipping-management-center" element={<ProtectedRoute requireAdmin={true}><ShippingManagementCenter /></ProtectedRoute>} />
        <Route path="/store-admin-management-center" element={<StoreAdminManagementCenter />} />
        <Route path="/invoice-audit-dashboard" element={<ProtectedRoute requireAdmin={true}><InvoiceAuditDashboard /></ProtectedRoute>} />
        <Route path="/event-invoice-compliance" element={<ProtectedRoute requireAdmin={true}><EventInvoiceComplianceDashboard /></ProtectedRoute>} />
        <Route path="/admin/master-invoice-center" element={<ProtectedRoute requireAdmin={true}><MasterInvoiceCenter /></ProtectedRoute>} />
        {/* 404 */}
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
    </ErrorBoundary>
  );
}
export default Routes;